import React, { useEffect, useRef, useState } from "react"
import { Asset, Link } from "../../../../plugins/gatsby-plugin-atollon"
import { graphql } from "gatsby"
import { gsap } from "gsap"
import { EdgeTop1 } from "../../icons"

const ProductBanner = ({ title, desktopImage, mobileImage, award, theme }) => {
    const headingRef = useRef()
    const edgeRef = useRef()
    const [edgeHeight, setEdgeHeight] = useState()

    React.useEffect(() => {
      const words = headingRef?.current?.querySelectorAll(".word")

      const tl = gsap.timeline({ defaults: { duration: 1, ease: "power4.out" } })

      tl.set(words, { overflow: "hidden" })
        .to({}, 0.3, {})
        .set(words, { y: 100, skewX: -10, rotateX: -1, opacity: 0, stagger: 0.1 });

      tl.set(headingRef.current, { opacity: 1 })
      tl.to(words, { y: 0, skewX: 0, rotateX: 0, opacity: 1, stagger: 0.1 }, "-=0.3")

      return () => {
        tl.kill()
      }
    }, [])

    return (
      <section className={`product-banner ${theme || ""}`}>
        <div className="product-banner__asset">
          { desktopImage && <Asset className="product-banner__bg product-banner__bg--desktop" asset={desktopImage} /> }
          { mobileImage && <Asset className="product-banner__bg product-banner__bg--mobile" asset={mobileImage} /> }
          { award && <span className='product-banner__award'><Asset asset={award} /></span> }
        </div>
        <div className="product-banner__title">
          {title &&
            <h1 ref={headingRef} style={{ opacity: 0 }}>
              {title.split(" ").map((el, index) => (
                <span key={index}><span
                  className={`word`}>{el}</span></span>
              ))}
            </h1>
          }
        </div>
        {theme === "woods" &&
          <div ref={edgeRef} className="product-banner__edge"
               style={{ top: -(edgeHeight) + 10 }}>
            <EdgeTop1 color="#FFFFFF" />
          </div>
        }
      </section>
    )
}

export default ProductBanner

export const query = graphql`
  fragment ProductBannerProps on DatoCmsProductBanner {
    ... on DatoCmsProductBanner {
      id
      title
      award {
        ...InternalAssetProps
      }
      desktopImage {
        ...InternalAssetProps
      }
      mobileImage {
        ...InternalAssetProps
      }
    }
  }
`